import {
  NavigationSection,
  NavigationDropdown,
  NavigationDropdownItem,
  NavigationItemButton,
  NavigationPopOut,
  NavigationPopOutButton,
  NavigationPopOutMenuContent,
  NavigationPopOutMenuItem,
  NavigationDropdownTrigger,
  NavigationDropdownContent,
} from '@orbit-ui/components/navigation';
import {Link, useMatchRoute} from '@tanstack/react-router';
import {CircleSmallIcon} from 'lucide-react';
import {useNavigation} from '@/features/navigation/hooks/useNavigation';

function PrimaryNavigation() {
  const sections = useNavigation();
  const matchRoute = useMatchRoute();

  return (
    <>
      {sections.map((section) => (
        <NavigationSection key={section.title} title={section.title}>
          {section.items.map((item) => {
            if ('to' in item) {
              return item.subMenuItems?.length ? (
                <NavigationPopOut>
                  <NavigationPopOutButton asChild>
                    <Link to={item.to}>
                      {item.icon ? <item.icon /> : <CircleSmallIcon />}
                      <span>{item.title}</span>
                    </Link>
                  </NavigationPopOutButton>
                  <NavigationPopOutMenuContent>
                    {item.subMenuItems.map((subItem) => (
                      <NavigationPopOutMenuItem key={subItem.title}>
                        {subItem.icon ? <subItem.icon /> : <CircleSmallIcon />}
                        <Link to={subItem.to}>{subItem.title}</Link>
                      </NavigationPopOutMenuItem>
                    ))}
                  </NavigationPopOutMenuContent>
                </NavigationPopOut>
              ) : (
                <NavigationItemButton key={item.title} asChild>
                  <Link to={item.to}>
                    {item.icon ? <item.icon /> : <CircleSmallIcon />}
                    <span>{item.title}</span>
                  </Link>
                </NavigationItemButton>
              );
            }

            const isActive = item.items.some((subItem) =>
              matchRoute({fuzzy: false, to: subItem.to}),
            );
            return (
              <NavigationDropdown key={item.title} isActive={isActive}>
                <NavigationDropdownTrigger>
                  {item.icon ? <item.icon /> : <CircleSmallIcon />}
                  <span>{item.title}</span>
                </NavigationDropdownTrigger>
                <NavigationDropdownContent>
                  {item.items.map((subItem) => (
                    <NavigationDropdownItem key={subItem.title}>
                      <Link to={subItem.to}>{subItem.title}</Link>
                    </NavigationDropdownItem>
                  ))}
                </NavigationDropdownContent>
              </NavigationDropdown>
            );
          })}
        </NavigationSection>
      ))}
    </>
  );
}

export {PrimaryNavigation};
